<template>
  <div>
    <vx-tooltip
      :delay="tooltipDelay"
      :text="tooltipText"
      :tooltipPosition="tooltipPosition"
    >
      <feather-icon
        icon="ListIcon"
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        @click="openSideList"
      />
    </vx-tooltip>
    <vs-popup :title="popupTitle" :active.sync="active" fullscreen>
      <vs-row class="my-3">
        <vs-col vs-w="3">
          <b>{{ $t('client') }}:</b> {{ data.ClientName }}
        </vs-col>
        <vs-col vs-w="5">
          <b>{{ $t('period') }}:</b> {{ data.WeekInvoice }}
        </vs-col>
        <vs-col vs-w="3">
          <vue-json-to-csv :json-data="this.expenses" csv-title="Export Test">
            <vs-button color="success" type="filled" class="w-full">
              Export
            </vs-button>
          </vue-json-to-csv>
        </vs-col>
      </vs-row>
      <vs-tabs position="top">
        <vs-tab icon-pack="feather" icon="icon-book" :label="$t('expenses')">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <expense-sidelist
              :data="expenses"
              :loadingMessage="loadingMessage"
            />
          </div>
        </vs-tab>
        <vs-tab icon-pack="feather" icon="icon-list" :label="$t('payroll')">
          <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
            <payroll-sidelist
              :data="payroll"
              :loadingMessage="loadingMessage"
            />
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
  </div>
</template>

<script>
import ExpenseSidelist from '@/views/apps/accounting/components/ExpenseSidelist.vue'
import PayrollSidelist from '@/views/apps/accounting/components/PayrollSidelist.vue'
import invoice from '@/http/requests/invoice'
import VueJsonToCsv from 'vue-json-to-csv'

export default {
  components: {
    ExpenseSidelist,
    VueJsonToCsv,
    PayrollSidelist,
  },
  data() {
    return {
      active: false,
      expenses: [],
      payroll: [],
      params: {},
      loadingMessage: '',
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    popupTitle: {
      type: String,
      default: 'title',
    },
    tooltipDelay: {
      type: String,
      default: '1.5s',
    },
    tooltipPosition: {
      type: String,
      default: 'top',
    },
    tooltipText: {
      type: String,
      default: null,
    },
    module: {
      type: String,
      required: true,
    },
  },
  methods: {
    openSideList() {
      this.active = true
      this.expenses = []
      this.payroll = []
      this.search()
    },
    search() {
      this.loadingMessage =this.$i18n.messages[this.$i18n.locale].loading + '...'
      // this.params.where = ['Expenses.ClientId=' + this.data.ClientId,'payrolls.client_id='+this.data.ClientId]
      this.params.clientId = this.data.ClientId
      this.params.invoiceId = this.data.InvoiceId
      this.params.module = this.module
      invoice.expensesAndPayrollList(this.params).then((res) => {
        this.expenses = res.data.expenses
        this.payroll = res.data.payroll
        if (res.data.expenses.length == 0 || res.data.payroll.length == 0) {
          this.loadingMessage =this.$i18n.messages[this.$i18n.locale].no_results
        }
      })
    },
  },
}
</script>